module.exports = __webpack_public_path__ + "img/lc1@2x.40efba18.png";